import { useGlobal } from '@/utils/useGlobal';
import PreSaleH5 from '@/componentsH5/PowerKitPreSale';
import PreSalePC from '@/components/PowerKitPreSale';

export default function PreSale({}: any) {
    const { useRouter, isMobile } = useGlobal();
    const router = useRouter();
    const activityId = router.query?.series;
    let presaleStatus = 1;
    if (typeof window !== 'undefined') {
        presaleStatus = 2;
    }

    const LayoutA = isMobile ? PreSaleH5 : PreSalePC;

    return (
        <div style={{ display: presaleStatus === 1 ? 'none' : 'unset' }}>
            <LayoutA activityId={activityId} />
        </div>
    );
}
